module.exports = __webpack_public_path__ + "img/login.58233ec6.jpg";